<template>
    <div class="chart-container">
        <svg ref="chart" class="chart-content" :height="elementHeight" width="100%">
            <g :transform="'translate(' + margin.left + ', ' + (margin.top + height) + ')'" text-anchor="middle">
                <g v-for="(tick, i) in xTicks" :key="i" class="tick" :transform="'translate(' + tick.x + ', 0)'">
                    <text y="24" class="label">{{ tick.text }}</text>
                </g>
            </g>

            <g :transform="'translate(' + margin.left + ', ' + (margin.top) + ')'">
                <line :x2="xScale(1)" class="grid"/>
                <g v-for="(point, i) in data.points" :key="point.id" :transform="'translate(' + xScale(point.estimate) + ', 0)'" text-anchor="middle"
                 @mouseover="hovered(point, i)" @mouseleave="hover = null" class="estimate-group" :class="{'hover': point.id == hover}">
                    <circle class="dot" r="12" :class="['fill-party-' + point.id]" />
                    <text y="-25" v-if="hover == point.id" class="note">{{ point.title}}</text>
                    <rect class="fill-blue-light" width="40" height="15" x="-20" y= "22" v-if="hover == point.id"/>
                    <text y="34" v-if="hover == point.id" class="note">{{ point.x | percentage(0) }}</text>
                </g>
            </g>
        </svg>
    </div>
</template>

<script>
import * as d3 from "d3";
import { map } from "lodash";
import { mapState } from "vuex";

export default {
    name: 'BarChart',
    props: ["data"],
    data () {
        return {
            visible: 0,
            hover: null,
            clientWidth: 600,
            elementHeight: 80,
        }
    },
    methods: {
        lighten (color, amount) {
            return color.replace(')', ', ' + amount + ')').replace('rgb', 'rgba')
        },
        handleResize () {
            if (this.$refs.chart) {
                this.clientWidth = this.$refs.chart.clientWidth;
            }
        },
        hovered (point, index) {
            this.hover = point.id;
            this.$emit("hover", index);
        }
    },
    computed: {
        ...mapState(["windowWidth"]),
        mobile() {
            return this.windowWidth < 800;
        },
        margin () {
            return {top: 40, right: 30, bottom: 30, left: 30};
        },
        labels() {
            return map(this.data.points, "title")
        },
        width () {
            return this.clientWidth - this.margin.left - this.margin.right;
        },
        height () {
            return this.elementHeight - this.margin.top - this.margin.bottom;
        },
        xScale () {
            return d3.scaleLinear().domain([0, 1]).range([0, this.width]);
        },
        xTicks () {
            let x = this.xScale.ticks(5);

            return map(x, (o) => ({x: this.xScale(o), text: o * 100 + " %"}));
        },
    },
    mounted () {
        this.handleResize();
        window.addEventListener('resize', this.handleResize)
    },
    beforeDestroy () {
        window.removeEventListener('resize', this.handleResize)
    }
}
</script>